<div class="container page-top mb-5">
  <h1 class="my-5">Download Again</h1>
  <p class="mb-4">
  You may download software products as many times as you need during the licensing term as long as you are an active student or active employee.
  If you need the serial number or license file, you can retrieve it on your order summary via
  <a [routerLink]="['/account-history']"> Order History </a>
  </p>

  <h2 class="mt-4">Available Downloads</h2>
  <app-download-list [downloadItems]="items"></app-download-list>
</div>
